import React from "react";
import FolieLayout from "./FolieLayout.jsx";
import MarkenZeitstrahlSchaubild from "./MarkenZeitstrahlSchaubild.jsx";

export default function Folie5Marken() {
    return (
        <FolieLayout
            nummer={6}
            titel="Die vier Marken"
            hilfe="T kritisch, T leer, T ideal und T spät markieren die wichtigen Zeitpunkte im Bestandsverlauf jedes Farbtons."
            text={
                <p className="mb-0">
                    Jeder Farbton bekommt vier Marken auf seinem Zeitstrahl: <strong>T kritisch</strong> – der
                    Sicherheitsbestand wird angebrochen; <strong>T leer</strong> – der Artikel ist aus;{" "}
                    <strong>T ideal</strong> – hier sollte bestellt werden; <strong>T spät</strong> – die letzte
                    Gelegenheit. Weil Cosmos nur zu bestimmten Lieferwochen liefert, wird auf die nächste passende
                    Liefergelegenheit vor dem rechnerischen Termin zurückgerundet.
                </p>
            }
            leseHinweis="Liegt die nächste erreichbare Liefergelegenheit hinter „T spät“, ist es bereits zu spät – dann hilft kein Bestellvorschlag mehr, sondern nur noch Umdisponieren. Genau das zeigt die rote Warnung rechts im Bild."
        >
            <MarkenZeitstrahlSchaubild />
        </FolieLayout>
    );
}
